import { ReportIcon } from 'src/components/ui-icons/sidebar';
import TableSummary from '../../table-summary/table-summary';
import { useNavigate } from 'react-router-dom';
import { useCallback, useEffect, useState, useRef, useMemo } from 'react';
import { filterConfigReportFactory, initialOpenReportFactory, months, years } from './filterDataFactory';
import { useAppDispatch, useAppSelector } from 'src/hooks/redux';
import { debounce, isEqual } from 'lodash';
import { getReportFactory } from 'src/modules/vpo/actions';
import FilterForPlanAction from '../../planAction/filterForPlanAction/FilterForPlanAction';
import Loading from 'src/components/Loading';
import ExcelExportReportFactory from '../../excel-export-report-factory/excel-export-report-factory';
import moment from 'moment';
import { selectCurrentUser } from 'src/modules/users/selector';
import { getDataReportFactory, getFetchingStatusReportFactory } from '../../../store/report-factory/selectors';
import { fetchReportFactoryRequestVPO } from '../../../store/report-factory/report-factory';
import { selectModelData } from '../../../store/filtersData/selector';
import { fetchData } from '../../../store/filtersData/actions';
import React from 'react';
import { transformDataForFilters, transformDataForFiltersFactory } from '../../../utils/plan_actions/plan_actions';

function ReportFactory() {
  const [filtersInitialized, setFiltersInitialized] = useState(false);
  const [currentFilters, setCurrentFilters] = useState<any>(null);
  const initialFiltersRef = useRef<any>(null);

  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const user = useAppSelector((state) => selectCurrentUser(state));

    // // Mock user
  // const user = {
  //   displayName: 'Kanashov Evgeny',
  //   infoVPO: {
  //     "user": true,
  //     "zone": false,
  //     "admin": false,
  //     "adminRegion": false,
  //     "directoryTitle": ["BOP", "VOP"],
  //     "factory": [
  //       {
  //         factoryID: 2,
  //         factoryTitle: "Владивосток",
  //       },
  //     ],
  //   }
  // };

  const FilterColumns = useAppSelector((state: any) => selectModelData(state, 'vpo-columns'));
  const FilteGroupAll = useAppSelector((state: any) => selectModelData(state, 'vpo-groups'));
  const FilterFactories = useAppSelector((state: any) => selectModelData(state, 'vpo-factories'));
  const FilterColumnBlock = useAppSelector((state: any) => selectModelData(state, 'vpo-column-blocks'));
  const FilterDepartments = useAppSelector((state: any) => selectModelData(state, 'vpo-departments'));

  const VpoAvailableQuestionnaire = useAppSelector((state: any) => selectModelData(state, 'vpo-available-questionnaires')).sort((a, b)=>a.id - b.id);

  const transformedColumns = React.useMemo(() => transformDataForFilters(FilterColumns), [FilterColumns]);
  const transformedGroups = React.useMemo(() => transformDataForFilters(FilteGroupAll), [FilteGroupAll]);
  const transformedFactories = React.useMemo(() => transformDataForFiltersFactory(FilterFactories), [FilterFactories]);
  const transformedColumnBlock = React.useMemo(() => transformDataForFilters(FilterColumnBlock), [FilterColumnBlock]);
  const transformDepartment = React.useMemo(() => transformDataForFilters(FilterDepartments), [FilterDepartments]);

  //! Определение месяца согласно из таблицы Vpo-available-questionnaire
  const getCurrentDate = (arrayEndQuestionary: any[]) => {
    const months = ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'];

    const validItems = arrayEndQuestionary.filter((item) => item.startDate && moment(item.startDate).isValid());

    if (validItems.length === 0) {
      const firstItem = arrayEndQuestionary[0];
      const monthIndex = months.indexOf(firstItem?.month);
      return {
        month: {
          id: monthIndex + 1,
          name: firstItem?.month,
        },
        year: {
          id: Number(firstItem?.year),
          name: String(firstItem?.year),
        },
      };
    }

    const currentMoment = moment();
    const startedItems = validItems.filter((item) => moment(item.startDate) <= currentMoment);

    const currentDate = startedItems.length > 0
      ? startedItems[startedItems.length - 1]
      : validItems[0];

    const monthIndex = months.indexOf(currentDate?.month);

    return {
      month: {
        id: monthIndex + 1,
        name: currentDate?.month,
      },
      year: {
        id: Number(currentDate?.year),
        name: String(currentDate?.year),
      },
    };
  };

  //! получаю даты для фильтров по месяцу
  useEffect(() => {
    dispatch(fetchData('vpo-available-questionnaires', {}, { page: 1, pageSize: 100 }));
  }, [dispatch]);

  //! Получаю группы, колонны
  useEffect(() => {
    dispatch(fetchData('vpo-groups', {}, { page: 1, pageSize: 100 }));
    dispatch(fetchData('vpo-columns', {}, { page: 1, pageSize: 100 }));
  }, [dispatch]);

  //! Загружаем заводы для группы пользователя ДО инициализации фильтров
  useEffect(() => {
    if (transformedGroups.length > 0 && user?.infoVPO && !filtersInitialized) {

      let userGroupId: number | null = null;
      if (user.infoVPO.directoryTitle?.length > 0) {
        const userGroups = user.infoVPO.directoryTitle;
        const priorityOrder = ['BOP', 'VOP', 'SOP'];
        const priorityTitle = priorityOrder.find((p) => userGroups.includes(p)) || userGroups[0];
        const userGroup = transformedGroups.find((g: any) => g.Title === priorityTitle);
        userGroupId = userGroup?.ID || transformedGroups[0]?.ID;
      } else if (transformedGroups[0]) {
        userGroupId = transformedGroups[0].ID;
      }

      if (userGroupId) {
        dispatch(fetchData('vpo-factories', { group: [userGroupId] }, { page: 1, pageSize: 100 }));
      }
    }
  }, [transformedGroups, user?.infoVPO, filtersInitialized, dispatch]);

  //! При изменении группы в фильтрах получаю заводы
  useEffect(() => {
    if (currentFilters?.groupPlanAction?.selectedIds) {
      dispatch(fetchData('vpo-factories', { group: currentFilters?.groupPlanAction?.selectedIds }, { page: 1, pageSize: 100 }));
    }
  }, [currentFilters?.groupPlanAction?.selectedIds, dispatch]);

  //! При изменении колонны получаю блок колонны
  useEffect(() => {
    if (currentFilters?.column?.selectedIds) {
      dispatch(
        fetchData(
          'vpo-column-blocks',
          { column: currentFilters?.column?.selectedIds },
          {
            page: 1,
            pageSize: 100,
          }
        )
      );
    }
  }, [currentFilters?.column?.selectedIds, dispatch]);

  //! При изменении завода и колонны получаю подразделение
  useEffect(() => {
    if (currentFilters?.reportFactory?.selectedIds && currentFilters?.column?.selectedIds) {
      dispatch(
        fetchData(
          'vpo-departments',
          {
            factories: currentFilters?.reportFactory?.selectedIds,
            columns: currentFilters?.column?.selectedIds,
          },
          {
            page: 1,
            pageSize: 100,
          }
        )
      );
    }
  }, [currentFilters?.reportFactory?.selectedIds, currentFilters?.column?.selectedIds, dispatch]);

  const reportFactory = useAppSelector(getDataReportFactory);
  const loadingReportFactory = useAppSelector(getFetchingStatusReportFactory);

  //! начальное состояние фильтров
  useEffect(() => {
    if (VpoAvailableQuestionnaire.length && !filtersInitialized && user?.infoVPO && transformedGroups.length > 0 && transformedFactories.length > 0) {
      const currentDate = getCurrentDate(VpoAvailableQuestionnaire);

      let defaultGroup: { ID: number; Title: string } | null = null;
      if (user.infoVPO.directoryTitle?.length > 0) {
        const userGroups = user.infoVPO.directoryTitle;
        const priorityOrder = ['BOP', 'VOP', 'SOP'];
        const priorityTitle = priorityOrder.find((p) => userGroups.includes(p)) || userGroups[0];
        defaultGroup = transformedGroups.find((g: any) => g.Title === priorityTitle) || transformedGroups[0];
      } else {
        defaultGroup = transformedGroups[0];
      }

      let defaultFactory: { ID: number; Title: string } | null = null;
      if (defaultGroup) {
        const userFactoryIds = Array.isArray(user.infoVPO.factory)
          ? user.infoVPO.factory.map((f: { factoryID: number }) => f.factoryID)
          : user.infoVPO.factory?.factoryID
          ? [user.infoVPO.factory.factoryID]
          : [];

        const factoriesInGroup = transformedFactories.filter((factory: any) => factory.VPOgroup && factory.VPOgroup.id === defaultGroup.ID);
        const availableFactories = factoriesInGroup.filter((factory: any) => userFactoryIds.includes(factory.ID));

        if (availableFactories.length > 0) {
          const sortedFactories = [...availableFactories].sort((a, b) => a.Title.localeCompare(b.Title));
          defaultFactory = sortedFactories[0];
        }
      }

      const initialFiltersReportFactory: any = {
        yearFactory: {
          selected: [currentDate.year.name],
          selectedIds: [currentDate.year.id],
          search: '',
        },
        monthFactory: {
          selected: [currentDate.month.name],
          selectedIds: [currentDate.month.id],
          search: '',
        },
        column: { selected: ['Менеджмент', 'Качество', 'Люди', 'Экология', 'Техобслуживание', 'Безопасность', 'Логистика'], selectedIds: [1, 2, 3, 4, 5, 6, 7], search: '' },
        columnBlockFactory: { selected: [], selectedIds: [], search: '' },
        subdivisionFactory: { selected: [], selectedIds: [], search: '' },
        groupPlanAction: defaultGroup
          ? { selected: [defaultGroup.Title], selectedIds: [defaultGroup.ID] }
          : { selected: [], selectedIds: [] },
        reportFactory: defaultFactory
          ? { selected: [defaultFactory.Title], selectedIds: [defaultFactory.ID], search: '' }
          : { selected: [], selectedIds: [], search: '' },
      };

      initialFiltersRef.current = initialFiltersReportFactory;
      setCurrentFilters(initialFiltersReportFactory);
      setFiltersInitialized(true);
    }
  }, [VpoAvailableQuestionnaire, user?.infoVPO, transformedGroups, transformedFactories, filtersInitialized]);

  const filterConfigs = {
    yearFactory: { items: years },
    monthFactory: { items: months },
    column: { items: transformedColumns },
    groupPlanAction: { items: transformedGroups },
    reportFactory: { items: transformedFactories },
    columnBlockFactory: { items: transformedColumnBlock },
    subdivisionFactory: { items: transformDepartment },
  };

  const filtersMap = {
    yearFactory: years,
    monthFactory: months,
    column: transformedColumns,
    groupPlanAction: transformedGroups,
    reportFactory: transformedFactories,
    columnBlockFactory: transformedColumnBlock,
    subdivisionFactory: transformDepartment,
  };

  const currentFiltersRef = useRef<any>(null);
  currentFiltersRef.current = currentFilters;

  const debouncedApplyFilters = useMemo(
    () =>
      debounce((newFilters: any) => {
        if (!isEqual(currentFiltersRef.current, newFilters)) {
          //! в консоли можешь посмотреть
          console.log('Новые фильтры:', newFilters);
          dispatch(getReportFactory(newFilters));
          setCurrentFilters(newFilters);
        }
      }, 1000),
    [dispatch]
  );

  useEffect(() => () => debouncedApplyFilters.cancel(), [debouncedApplyFilters]);

  //! обновление фильтров в начальном состоянии
  const handleFiltersChange = useCallback(
    (newFilters: any) => {
      debouncedApplyFilters(newFilters);
    },
    [debouncedApplyFilters]
  );

  useEffect(() => {
    if (currentFilters && currentFilters.reportFactory?.selectedIds?.length > 0) {
      dispatch(getReportFactory(currentFilters));
    }
  }, [currentFilters, dispatch]);

  useEffect(() => {
    if (currentFilters) {
      dispatch(
        fetchReportFactoryRequestVPO({
          group: currentFilters.groupPlanAction.selectedIds,
          year: currentFilters.yearFactory.selected,
          month: currentFilters.monthFactory.selectedIds,
          column: currentFilters.column.selectedIds,
          factory: currentFilters.reportFactory.selectedIds,
          filters: currentFilters,
        })
      );
    }
  }, [currentFilters, dispatch]);

  console.log('reportFactory', reportFactory?.data);
  console.log('currentFilters', currentFilters);

  if (!currentFilters) {
    return <Loading />;
  }

  return (
    <div className='flex justify-between w-full h-full'>
      <div className='w-[320px] mr-2 bg-white'>
        <FilterForPlanAction
          onFiltersChange={handleFiltersChange}
          filterConfigs={filterConfigs}
          filtersMap={filtersMap}
          initialFilters={initialFiltersRef.current || {}}
          filtersOpen={initialOpenReportFactory}
          filtersConfig={filterConfigReportFactory}
          responsibleFil={true}
          heightFilter={'h-[calc(100vh-2px)]'}
        />
      </div>
      <div className='flex-1 min-w-0 m-6'>
        <div className='flex items-center text-gray-600 mb-6'>
          <span className='pr-3'>
            <ReportIcon />
          </span>
          <span className='cursor-pointer text-base' onClick={() => navigate('/dashboard/6/reports')}>
            Отчеты
          </span>
          <span className='mx-2'>→</span>
          <span className='text-base'>Отчет по заводу</span>

          {reportFactory && <ExcelExportReportFactory data={reportFactory?.data} departments={reportFactory?.departments} params={{group: currentFilters.groupPlanAction.selected[0]}} />}
        </div>
        <div className='min-w-0'>
          {!currentFilters?.reportFactory.selected || !currentFilters?.reportFactory.selected.length ? (
            'Выберите завод'
          ) : (
            <>
              {loadingReportFactory
                ?
                  <Loading />
                :
                <>
                  {reportFactory &&
                    <TableSummary
                      data={reportFactory?.data}
                      dataHead={reportFactory?.departments}
                      category='factory'
                      departments={reportFactory?.departments}
                    />
                  }
                </>
              }
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default ReportFactory;
